export default __webpack_public_path__ + "static/media/interviewer-avatar.41692c25.svg";